import { defineMessages } from "react-intl";

const baseId = "t.components.footer.";

export default defineMessages({
  version: {
    id: baseId + "version",
    defaultMessage: "Version",
  },
});
